<div class="p-0 min-w-[500px]" >
    <p-tabs value="0" class="p-0 activity-tabs">
        <p-tablist >
            <p-tab value="0">Activity</p-tab>
            <p-tab value="1">Note</p-tab>
            <p-tab value="2" *ngIf="accessObject.isEmailAccess">Email</p-tab>
            <p-tab value="3">Task</p-tab>
            <p-tab value="4" *ngIf="accessObject.isMeetingAccess">Meeting</p-tab>
            <p-tab value="5" *ngIf="accessObject.isCallAccess">Call</p-tab>
            <p-tab value="6" *ngIf="editType != 'admission'">Follow Ups</p-tab>
            <p-tab value="7" *ngIf="editType == 'registration' || editType == 'application' || editType == 'enrollment' || editType == 'admission'">Documents</p-tab>

        </p-tablist>
        <p-tabpanels class="p-0">
            <p-tabpanel value="0">
                <p class="m-0">
                   <app-lead-timeline  [timelineData]="leadActivity"></app-lead-timeline>
                </p>
            </p-tabpanel>
            <p-tabpanel value="1">
                <p class="m-0">
                    <app-lead-timeline [timelineData]="leadNotes" 
                      [isUpdate]="true"
                      [isDelete]="true"
                      [title]="'Notes Timeline'"
                    ></app-lead-timeline>
                </p>
            </p-tabpanel>
            <p-tabpanel value="2">
                <p class="m-0">
                    <app-lead-timeline  
                    [title]="'Email Timeline'"
                    [timelineData]="leadEmailCommunication"></app-lead-timeline>
                </p>
            </p-tabpanel>
            <p-tabpanel value="3">
                <p class="m-0">
                    <app-lead-timeline 
                    [title]="'Task Timeline'"
                    [isUpdate]="true"
                    [isDelete]="true"
                    [timelineData]="leadTasks"></app-lead-timeline>
                </p>
            </p-tabpanel>
            <p-tabpanel value="4">
                <p class="m-0">
                    <app-lead-timeline  
                    [title]="'Metting Timeline'"
                    [timelineData]="leadMeeting"></app-lead-timeline>
                </p>
            </p-tabpanel>
            <p-tabpanel value="5">
                <p class="m-0">
                    <app-lead-timeline 
                    [title]="'Call Timeline'"
                    [timelineData]="leadCallCommunication"></app-lead-timeline>
                </p>
            </p-tabpanel>
            <p-tabpanel value="6">
                <p class="m-0">
                    <app-lead-timeline  
                    [title]="'Follow Ups Timeline'"
                    [timelineData]="leadFollowUps"></app-lead-timeline>
                </p>
            </p-tabpanel>

            <p-tabpanel value="7">
                <p class="m-0">
                    <app-lead-timeline  
                    [title]="'Document Timeline'"
                    [isDelete]="true"
                    [timelineData]="leadDocuments"></app-lead-timeline>
                </p>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>